import React from 'react';
import {Flex} from '/app/src/component';
import Theme from '/app/src/theme';
import SVG from 'react-inlinesvg';

const textStyle = {
    color: "JibberPurple_L",
    fontSize: "28px",
    fontWeight: "500",
    vAlignContent: "center"
}

const containerStyle = {
    padding: "10px 50px 0 50px"
}

const Header = ({icon, text}) => (
    <Flex {...containerStyle}>
        <Flex vAlignContent="center">
            <SVG
                cacheGetRequests={true}
                src={icon}
                style={{
                    fill: Theme.colors.JibberPurple_L,
                    width: "55px",
                    height: "55px",
                    marginRight: "15px"
                    }}/>
        </Flex>
        <Flex {...textStyle}>
            {text}
        </Flex>
    </Flex>
)

export default Header;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/Header.js